export function getDomainName(hostname?: string): string {
  return (hostname || window.location.hostname).split(".").slice(-2).join(".");
}
